/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Prospects1Inputs */

const en_coinvestments_prospects1 = /** @type {(inputs: Coinvestments_Prospects1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prospects`)
};

/**
* | output |
* | --- |
* | "prospects" |
*
* @param {Coinvestments_Prospects1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_prospects1 = /** @type {((inputs?: Coinvestments_Prospects1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Prospects1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_prospects1(inputs)
});
export { coinvestments_prospects1 as "coInvestments_prospects" }